/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './AppTooltip.scss';

function AppTooltip({
  title,
  content,
  tooltipClassName,
  titleClassName,
  contentClassName,
}) {
  const [showTooltip, setShowTooltip] = useState(true);
  return (
    <div
      className={`app-tooltip ${tooltipClassName}`}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(true)}
    >
      <div className={`app-tooltip_title ${titleClassName}`}>{title}</div>
      {showTooltip && (
        <div className={`app-tooltip_content ${contentClassName}`}>
          {content}
        </div>
      )}
    </div>
  );
}

AppTooltip.defaultProps = {
  tooltipClassName: '',
  titleClassName: '',
  contentClassName: '',
};

AppTooltip.propTypes = {
  title: PropTypes.any.isRequired,
  tooltipClassName: PropTypes.any,
  titleClassName: PropTypes.any,
  contentClassName: PropTypes.any,
  content: PropTypes.any.isRequired,
};

export default AppTooltip;
